module.exports = __webpack_public_path__ + "media/images/default/default_user_icon_type_1-c9ec46cb0e915154aa3994e0e8c1462d.png";